module.exports = __webpack_public_path__ + "media/audio29.4eb69778.mp3";